module.exports = __webpack_public_path__ + "entry-150bfe9b/edeka-photo-7c2aee4bcd9750ad6805eaea92271609.webp";